import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import { USER_HINTS } from "./userHints.constants";
import { getAppFeatures, getIsFirstDealDoneSelector } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";

const userHintsSelector = (state: IRootState) => state.userHints;

export const getUserHintsSelector = createSelector(userHintsSelector, state => state.userHints);

export const getBuySellUserHintSeenSelector = createSelector(userHintsSelector, state => !!state.userHints.find(hint => hint.hint_name === USER_HINTS.BUY_SELL));

export const getDemoLimitsUserHintSeenSelector = createSelector(userHintsSelector, state => !!state.userHints.find(hint => hint.hint_name === USER_HINTS.DEMO_LIMITS));

export const getBuySellUserHintLoadingSelector = createSelector(userHintsSelector, state => state.isLoading);

export const getUserHintsErrorSelector = createSelector(userHintsSelector, state => state.error);

export const getDemoLimitsHintShownSelector = createSelector(userHintsSelector, state => state.demoLimitsHintShown);

export const getBuySellHintShownSelector = createSelector(userHintsSelector, state => state.buySellHintShown);

export const getShouldTriggerBuySellOrderProtectionSelector = createSelector(userHintsSelector, state => state.shouldTriggerBuySellOrderProtection);

export const getBuySellHintAvailableSelector = createSelector([userHintsSelector, getBuySellUserHintSeenSelector, getBuySellUserHintLoadingSelector, getIsFirstDealDoneSelector, getAppFeatures], (state, isBuySellHintSeen, isBuySellHintSeenLoading, isFirstDealDone, features) => {
    return !isBuySellHintSeen && !isBuySellHintSeenLoading && !isFirstDealDone && !!features[FEATURES.HINTS];
});